import { DefaultState } from '@src/redux/types'

import {
  GENERATE_PROOF_OF_STUDY,
  GENERATE_TRANSCRIPT,
  STUDENT,
  STUDENT_ACHIEVEMENT_RECORDS,
  STUDENT_ALL,
  STUDENT_CONTACT_INFO,
  STUDENT_DELETE,
  STUDENT_FULL_INFO,
  STUDENT_GUARD_CREATE,
  STUDENT_GUARD_LIST,
  STUDENT_LIST,
  STUDENT_PERSONAL_INFO,
  STUDENT_PUBLIC_ID_CARD,
  STUDENT_PUBLIC_STUDY_PROOF,
  STUDENT_PUBLIC_TRANSCRIPT,
  STUDENT_STATUS_UPDATE,
  STUDENT_STUDY_PROOF_GENERATE,
  STUDENT_USERNAME,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [GENERATE_TRANSCRIPT]: DefaultState<`${typeof API.GENERATE_TRANSCRIPT}`, 'post'>
  [GENERATE_PROOF_OF_STUDY]: DefaultState<`${typeof API.GENERATE_PROOF_OF_STUDY}`, 'post'>
  [STUDENT]: DefaultState<`${typeof API.STUDENT}{id}`, 'get'>
  [STUDENT_ACHIEVEMENT_RECORDS]: DefaultState<`${typeof API.STUDENT_ACHIEVEMENT_RECORDS}`, 'get'>
  [STUDENT_ALL]: DefaultState<`${typeof API.STUDENT_ALL}`, 'get'>
  [STUDENT_CONTACT_INFO]: DefaultState<`${typeof API.STUDENT_CONTACT_INFO}`, 'put'>
  [STUDENT_DELETE]: DefaultState<`${typeof API.STUDENT}{id}`, 'delete'>
  [STUDENT_GUARD_CREATE]: DefaultState<`${typeof API.STUDENT_GUARD}`, 'post'>
  [STUDENT_GUARD_LIST]: DefaultState<`${typeof API.STUDENT_GUARD}`, 'get'>
  [STUDENT_LIST]: DefaultState<`${typeof API.STUDENT}`, 'get'>
  [STUDENT_PERSONAL_INFO]: DefaultState<`${typeof API.STUDENT_PERSONAL_INFO}`, 'put'>
  [STUDENT_FULL_INFO]: DefaultState<`${typeof API.STUDENT_FULL_INFO}`, 'put'>
  [STUDENT_STATUS_UPDATE]: DefaultState<`${typeof API.STUDENT_STATUS}`, 'put'>
  [STUDENT_USERNAME]: DefaultState<`${typeof API.STUDENT_USERNAME}{username}`, 'get'>
  [STUDENT_PUBLIC_TRANSCRIPT]: DefaultState<`${typeof API.STUDENT_PUBLIC_TRANSCRIPT}`, 'get'>
  [STUDENT_PUBLIC_STUDY_PROOF]: DefaultState<`${typeof API.STUDENT_PUBLIC_STUDY_PROOF}`, 'get'>
  [STUDENT_PUBLIC_ID_CARD]: DefaultState<`${typeof API.STUDENT_PUBLIC_ID_CARD}`, 'get'>
  [STUDENT_STUDY_PROOF_GENERATE]: DefaultState<`${typeof API.STUDENT_STUDY_PROOF_GENERATE}`, 'post'>
} = () => ({
  [GENERATE_PROOF_OF_STUDY]: defaultState(),
  [GENERATE_TRANSCRIPT]: defaultState(),
  [STUDENT]: defaultState(),
  [STUDENT_ACHIEVEMENT_RECORDS]: defaultState(),
  [STUDENT_ALL]: defaultState(),
  [STUDENT_CONTACT_INFO]: defaultState(),
  [STUDENT_DELETE]: defaultState(),
  [STUDENT_GUARD_CREATE]: defaultState(),
  [STUDENT_GUARD_LIST]: defaultState(),
  [STUDENT_LIST]: defaultState(),
  [STUDENT_PERSONAL_INFO]: defaultState(),
  [STUDENT_FULL_INFO]: defaultState(),
  [STUDENT_STATUS_UPDATE]: defaultState(),
  [STUDENT_USERNAME]: defaultState(),
  [STUDENT_PUBLIC_TRANSCRIPT]: defaultState(),
  [STUDENT_PUBLIC_STUDY_PROOF]: defaultState(),
  [STUDENT_PUBLIC_ID_CARD]: defaultState(),
  [STUDENT_STUDY_PROOF_GENERATE]: defaultState(),
})
